import React from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import {
    Card,
    CardMedia,
    CardContent,
    Typography,
    Box,
} from '@mui/material'

const VenueBoxMarketplace = ({ venue }) => {
    const history = useHistory()

    const handleClick = () => {
        history.push(`/venue/${venue.venueId}`)
    }

    return (
        <Card
            className="venue-card"
            onClick={handleClick}
            sx={{
                height: '100%', // Make card fill the grid item height
                width: '100%', // Make card fill the grid item width
                borderRadius: '12px',
                boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                overflow: 'hidden',
                '&:hover': {
                    transform: 'scale(1.02)',
                    boxShadow: '0 16px 32px rgba(0, 0, 0, 0.15)',
                },
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <CardMedia
                component="div"
                sx={{
                    position: 'relative',
                    height: 0,
                    paddingTop: '56.25%',
                    width: '100%',
                    borderRadius: '8px 8px 0 0',
                }}
            >
                <Box
                    component="img"
                    src={venue.coverPhoto}
                    alt={venue.title}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
            </CardMedia>
            <CardContent sx={{ flexGrow: 1 }}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h6" component="div" noWrap>
                        {venue.title}
                    </Typography>
                    <Box 
                        display="flex" 
                        alignItems="center" 
                        gap={0.5}
                    >
                        <Box
                            component="span"
                            sx={{ 
                                color: '#FFB800',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '18px'
                            }}
                        >
                            ★
                        </Box>
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                fontWeight: 500,
                                fontSize: '14px',
                                color: 'text.secondary'
                            }}
                        >
                            4.95
                        </Typography>
                    </Box>
                </Box>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1 }}
                >
                    {venue.neighborhood}
                </Typography>
            </CardContent>
        </Card>
    )
}

VenueBoxMarketplace.propTypes = {
    venue: PropTypes.shape({
        venueId: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        startPrice: PropTypes.number.isRequired,
        coverPhoto: PropTypes.string,
        neighborhood: PropTypes.string,
    }).isRequired,
}

export default VenueBoxMarketplace
